import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const TopVendedoresChart = ({ data = [] }) => {
  // Colores alternos para las barras
  const colors = ['#a855f7', '#f97316', '#3b82f6', '#22c55e', '#ef4444'];

  return (
    <div className="statistics-chart" style={{ height: '400px', width: '100%' }}>
      <h3 className="statistics-title" style={{ marginBottom: '20px' }}>Vendedores top 5</h3>
      
      <ResponsiveContainer width="100%" height="90%">
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" />
          <XAxis 
            dataKey="vendedor" 
            angle={-45} 
            textAnchor="end" 
            interval={0} 
            tick={{ fontSize: 12, fill: '#6b7280' }}
            height={60}
          />
          <YAxis tick={{ fontSize: 12, fill: '#6b7280' }} />
          <Tooltip 
            cursor={{ fill: 'rgba(0,0,0,0.05)' }}
            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
          />
          <Bar dataKey="total_ventas" radius={[4, 4, 0, 0]} barSize={40}>
              {data.map((entry, index) => (
                <Cell key={entry.vendedor} fill={colors[index % colors.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

TopVendedoresChart.propTypes = {
  data: PropTypes.array,
};

export default TopVendedoresChart;